/**
 * Frontend script for tabs block
 * Handles tab switching on click and moves headers to header row
 */

function initTabs() {
	const tabsContainers = document.querySelectorAll('.regenerativa-tabs');

	tabsContainers.forEach((container) => {
		const tabs = container.querySelectorAll('.regenerativa-tab');
		const headerRow = container.querySelector('.tabs-header-row');

		if (!headerRow || tabs.length === 0) return;

		// Move all tab headers to the header row
		tabs.forEach((tab, index) => {
			const tabHeader = tab.querySelector('.tab-header');
			if (tabHeader) {
				// Clone header for the row
				const headerClone = tabHeader.cloneNode(true);
				const tabIndex = index;

				// Add click handler to header clone
				headerClone.addEventListener('click', () => {
					// Remove active class from all tabs
					tabs.forEach((t) => t.classList.remove('is-active'));

					// Remove active class from all headers
					const allHeaders = headerRow.querySelectorAll('.tab-header');
					allHeaders.forEach((h) => h.classList.remove('is-active'));

					// Add active class to this tab
					tab.classList.add('is-active');

					// Add active class to this header
					headerClone.classList.add('is-active');
				});

				headerRow.appendChild(headerClone);
			}
		});

		// Hide original headers in tabs
		tabs.forEach((tab) => {
			const tabHeader = tab.querySelector('.tab-header');
			if (tabHeader) {
				tabHeader.style.display = 'none';
			}
		});

		// Set first tab as active by default
		if (tabs.length > 0) {
			tabs[0].classList.add('is-active');
			const firstHeader = headerRow.querySelector('.tab-header');
			if (firstHeader) firstHeader.classList.add('is-active');
		}
	});
}

document.addEventListener('DOMContentLoaded', initTabs);

// For dynamic content (if tabs are added after page load)
if (
	document.readyState === 'interactive' ||
	document.readyState === 'complete'
) {
	initTabs();
}
